import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Pastel palette + label. First is the default (purple).
const THEMES = [
  { key: "purple", label: "Lavender",   swatch: "#B39BD8" },
  { key: "pink",   label: "Blossom",    swatch: "#F4A8CD" },
  { key: "blue",   label: "Sky",        swatch: "#89B0DE" },
  { key: "green",  label: "Sage",       swatch: "#8FC79F" },
  { key: "yellow", label: "Buttercup",  swatch: "#F5D694" },
];

const STORAGE_KEY = "lc_theme";

export function applyTheme(key) {
  const cls = "theme-" + key;
  const body = document.body;
  THEMES.forEach((t) => body.classList.remove("theme-" + t.key));
  body.classList.add(cls);
}

export function useThemeInit() {
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) || "purple";
    applyTheme(saved);
  }, []);
}

export default function ThemePicker() {
  const [active, setActive] = useState(() => localStorage.getItem(STORAGE_KEY) || "purple");
  const [open, setOpen] = useState(false);

  useEffect(() => { applyTheme(active); localStorage.setItem(STORAGE_KEY, active); }, [active]);

  return (
    <div
      className="fixed right-3 md:right-4 top-1/2 -translate-y-1/2 z-40 flex flex-col items-center gap-2 select-none"
      data-testid="theme-picker"
    >
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="theme-picker-toggle"
        title="Change theme"
        className="w-9 h-9 rounded-full bg-white/80 backdrop-blur border border-kawaii-border shadow-sm flex items-center justify-center hover:shadow-md transition-shadow"
      >
        <span className="text-base leading-none">🎨</span>
      </button>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex flex-col gap-2 rounded-full bg-white/85 backdrop-blur border border-kawaii-border shadow-md px-1.5 py-2"
        >
          {THEMES.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              data-testid={`theme-${t.key}`}
              title={t.label}
              className={`w-6 h-6 rounded-full transition-transform hover:scale-110 ${
                active === t.key ? "ring-2 ring-offset-2 ring-offset-white ring-kawaii-text/40 scale-105" : ""
              }`}
              style={{ background: t.swatch }}
              aria-label={`${t.label} theme`}
            />
          ))}
        </motion.div>
      )}
    </div>
  );
}
